import { create } from "zustand";
import { useAuthenticationStore } from "./auth";

const launchKey = "fruitify.bud.creation-launch";
const launchOwner = (state) =>
  `${state.user.info?.id}:${state.user.signInSession}:${state.user.info?.activeContext?.roleAssignment?.id}`;
export const readBudLaunch = (owner) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(launchKey));
    return saved?.owner === owner ? saved.context : null;
  } catch {
    return null;
  }
};

export const useAssistantStore = create((set, get) => ({
  fullPageLaunch: null,
  setFullPageLaunch: (context) => {
    try {
      if (context)
        sessionStorage.setItem(
          launchKey,
          JSON.stringify({
            owner: launchOwner(useAuthenticationStore.getState()),
            context,
          }),
        );
      else sessionStorage.removeItem(launchKey);
    } catch {
      /* Storage can be unavailable; the current navigation still works. */
    }
    set({ fullPageLaunch: context });
  },
  isEmbeddedOpen: false,
  isMinimized: false,
  currentContext: null,
  conversationId: null,
  messages: [],
  assignmentName: null,
  className: null,

  openEmbedded: (context, assignmentName = null, className = null) => {
    const state = get();
    if (state.isEmbeddedOpen && state.currentContext) {
      // Already open — return false to indicate conflict
      return false;
    }
    set({
      isEmbeddedOpen: true,
      currentContext: context,
      assignmentName,
      className,
      conversationId: null,
      messages: [],
    });
    return true;
  },

  replaceEmbedded: (context, assignmentName = null, className = null) => {
    set({
      isEmbeddedOpen: true,
      isMinimized: false,
      currentContext: context,
      assignmentName,
      className,
      conversationId: null,
      messages: [],
    });
  },

  closeEmbedded: () => {
    set({
      isEmbeddedOpen: false,
      isMinimized: false,
      currentContext: null,
      assignmentName: null,
      className: null,
      conversationId: null,
      messages: [],
    });
  },

  minimizeEmbedded: () => {
    set({ isMinimized: true });
  },

  restoreEmbedded: () => {
    set({ isMinimized: false });
  },

  setMessages: (messages) => set({ messages }),
  setConversationId: (id) => set({ conversationId: id }),
}));

// Clear student/conversation data when the acting account or school role changes.
useAuthenticationStore.subscribe((state, previous) => {
  const identity = (s) =>
    [
      s.user.info?.id,
      s.user.signInSession,
      s.user.info?.activeContext?.roleAssignment?.id,
    ].join(":");
  if (identity(state) !== identity(previous)) {
    useAssistantStore.getState().closeEmbedded();
    useAssistantStore.getState().setFullPageLaunch(null);
  }
});
